import { render } from "./MenuHamburguer.vue?vue&type=template&id=2a880443&lang=pug"
import script from "./MenuHamburguer.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuHamburguer.vue?vue&type=script&setup=true&lang=js"

import "./MenuHamburguer.vue?vue&type=style&index=0&id=2a880443&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__